import { API_BASE_URL } from '../config/apiBase';
import { getWellandStoredToken } from './storageKeys';
import { refreshAccessToken } from './refreshAccessToken';

function buildUrl(pathOrUrl) {
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
    const p = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
    return `${API_BASE_URL}${p}`;
}

/**
 * Fetch с Bearer и cookie; при 401 один раз обновляет access через refresh cookie.
 * @param {string} pathOrUrl путь вида /api/... или полный URL
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export async function fetchWithAuthRetry(pathOrUrl, init = {}) {
    const url = buildUrl(pathOrUrl);
    const { headers: initHeaders, ...rest } = init;

    const doFetch = (accessToken) => {
        const headers = { ...(initHeaders || {}) };
        if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
        return fetch(url, { ...rest, headers, credentials: 'include' });
    };

    let token = getWellandStoredToken();
    let res = await doFetch(token);
    if (res.status === 401) {
        const newTok = await refreshAccessToken();
        if (newTok) {
            token = newTok;
            res = await doFetch(token);
        }
    }
    return res;
}

/**
 * JSON API с автопродлением сессии.
 * @param {string} path путь от корня API, например /api/projects
 */
export async function authenticatedJsonRequest(path, init = {}) {
    const res = await fetchWithAuthRetry(path, {
        ...init,
        headers: {
            ...(init.headers || {}),
        },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data?.message || `HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}
